import React from "react";
import qrcode from "./qrcodeGenerator";

/**
 * Renders a QR code as a crisp inline SVG using the vendored qrcode-generator
 * library (MIT, Kazuhiko Arase) — no external dependency, works offline/print.
 */
/**
 * @param {object} props
 * @param {string} props.value - data to encode
 * @param {number} [props.size=96] - rendered pixel size
 * @param {"L"|"M"|"Q"|"H"} [props.level="M"] - error-correction level. Use "L" for the NIC
 *   signed e-Invoice QR: that payload is a ~1-1.4 KB JWS, which overflows level "M"
 *   (max ~1663 bytes at version 40) once the signature grows. "L" allows ~2953 bytes.
 * @param {string} [props.label] - accessible label
 */
export function QrCodeSvg({ value, size = 96, level = "M", label = "QR code" }) {
    if (!value) return null;
    let qr;
    try {
        qr = qrcode(0, level); // type 0 = auto-fit
        qr.addData(String(value));
        qr.make();
    } catch (e) {
        console.error("[QrCodeSvg] QR generation failed:", e, "length:", String(value).length);
        return null;
    }
    const count = qr.getModuleCount();
    const quiet = 2; // quiet-zone modules around the code
    const total = count + quiet * 2;
    const rects = [];
    for (let r = 0; r < count; r++) {
        for (let c = 0; c < count; c++) {
            if (qr.isDark(r, c)) {
                rects.push(<rect key={`${r}-${c}`} x={c + quiet} y={r + quiet} width={1} height={1} />);
            }
        }
    }
    return (
        <svg
            width={size}
            height={size}
            viewBox={`0 0 ${total} ${total}`}
            shapeRendering="crispEdges"
            role="img"
            aria-label={label}
        >
            <rect width={total} height={total} fill="#ffffff" />
            <g fill="#000000">{rects}</g>
        </svg>
    );
}
